import React from 'react';

export interface TooltipMobileActionProps {
  onClick: () => void;
}

export class TooltipMobileAction extends React.Component<TooltipMobileActionProps, {}> {
  onClick = (e) => {
    e.stopPropagation();
    this.props.onClick();
  };

  render() {
    return (
      <li role='button' onClick={this.onClick}>
        {this.props.children}
      </li>
    );
  }
}

export const TooltipMobileMenu = ({ children }) => {
  return <ul className='noble-mobile-tooltip'>{children}</ul>;
};
